import { Injectable,Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { dataInsights, dataInsightsLoadLoadFail, dataInsightsLoadSuccess } from './data-insight.actions';
import {DataInsightService} from '../service/data-insight.service'
import { REGISTRY_APPLICATION } from '../../global/tokens';



@Injectable()
export class DataInsightEffects {

  dataInsight$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dataInsights),
    switchMap((req) => {
      const apiCall =
        this.application === 'Admin'
          ? this.studyService.getDataInsightsChartsData(req?.userID)
          : this.studyService.getDataInsightsChartsData();

      return apiCall.pipe(
        map((res) => dataInsightsLoadSuccess({ res })),
        catchError(({ error }) => of(dataInsightsLoadLoadFail({ error })))
      );
    })
  )
);

    constructor(
    @Inject(REGISTRY_APPLICATION) private application: string,
    private actions$: Actions,
    private studyService: DataInsightService,
     ) {}
}